export default __webpack_public_path__ + "static/media/spa-image-03.6adbe903.jpg";